import { TimelineLite } from 'gsap';


export class BallAnimations {
  constructor({
    stepCount = 100,
    scales = [.33, .38, .43, .47, .53, .58, .62, .66],
    lastScale = .68,
    positions = [0, 10, 24, 40, 56, 72, 86, 99],
  } = {}) {
    this.stepCount = stepCount;
    this.scales = scales;
    this.positions = positions;
    this.points = [];
    this._scales = [];
    for (let i = 1; i < this.positions.length; i++) {
      const start = this.positions[i - 1];
      const end = this.positions[i];
      const difference = end - start;

      const startScale = this.scales[i - 1];
      const endScale = this.scales[i];
      const scalesDifference = endScale - startScale;
      const scaleStep = scalesDifference / difference;
      this._scales.push(
        ...new Array(difference).fill(null).map((_, i) => {
          return startScale + i * scaleStep;
        }));
    }
    this._scales.push(lastScale);
  }

  getCoordinate(start) {
    return this.points[this.positions[start]];
  }

  getScale(start) {
    return this._scales[this.positions[start]];
  }

  moveElements(element, start, end, delay, rotate = 8) {
    return new Promise(res => {
      const initial = new TimelineLite();
      const scales = [...this._scales].slice(this.positions[start], this.positions[end] + 1);
      const points = [...this.points].slice(this.positions[start], this.positions[end] + 1);
      const rotation = rotate;

      if (start === 0 && delay) {
        initial.to(
          element,
          {
            delay,
            duration: .2,
            pixi: {
              scale: scales[0],
              alpha: 1,
            },
          },
        );
      } else {
        element.alpha = 1;
      }

      points.reduce((line, point, index, { length }) => {
        return line.to(
          element,
          {
            duration: .01,
            angle: index * rotation,
            x: point.x,
            y: point.y,
            pixi: {
              scale: scales[index],
              alpha: 1,
            },
            onComplete: () => {
              if (length - index === 1) {
                res(true);
              }
            },
          },
        );
      }, initial);
    });
  }

  moveElementsBack(element, start, end, delay, rotate = 8) {
    return new Promise(res => {
      const initial = new TimelineLite();
      const scales = [...this._scales].slice(this.positions[start], this.positions[end] + 1);
      const points = [...this.points].slice(this.positions[start], this.positions[end] + 1);
      const rotation = rotate;
      const reversedPoints = points.reverse();

      reversedPoints.reduce((line, point, index, { length }) => {

        return line.to(
          element,
          {
            duration: .01,
            angle: index * rotation,
            x: point.x,
            y: point.y,
            pixi: {
              scale: scales[length - index],
              alpha: 1,
            },
            onComplete: () => {
              if (length - index === 1) {
                res(true);
                initial.to(
                  element,
                  {
                    delay: 0,
                    duration: .5,
                    pixi: {
                      scale: 0,
                      alpha: 0,
                    },
                  },
                );
              }
            },
          },
        );
      }, initial);
    });
  }

  setPoints(points) {
    this.points = points;
  }
}
